import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Common.css'; // 공통 스타일

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/'); // 홈으로 이동
  };

  return (
    <div className="common-container not-found">
      <h1>404 - 페이지를 찾을 수 없습니다</h1>
      <p>요청하신 페이지가 존재하지 않거나, 잘못된 경로로 접근하셨습니다.</p>
      <button onClick={handleGoHome} className="go-home-button">홈으로 돌아가기</button>
    </div>
  );
};

export default NotFoundPage;
